import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NoTargetShowRouterLink',
    props: {
        custom: { type: Boolean },
        activeClass: {},
        exactActiveClass: {},
        ariaCurrentValue: {},
        viewTransition: { type: Boolean },
        to: {},
        replace: { type: Boolean }
    },
    setup: function (__props) {
        // 据说可以用 tag 属性管理 routerlink的渲染标签，但我实测无效，所以先写一个这个组件
        var router = useRouter();
        var props = __props;
        var to = function () {
            router.push(props.to);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: "no-target-show-router-link",
                onClick: to
            }, [
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
